import { Injectable } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';
import { CookieService } from './cookie.service';

@Injectable({
  providedIn: 'root',
})
// Каждый клиент (инстанс) должен иметь уникальный ключ, который он генерирует себе сам
// И запоминает в куку
// все запросы на получение и рефреш токенов дожны содержать этот ключ

// Этот сервис будет следить за тем, что в куках есть ключ
// подпихивать мы его будем в интерсепторе AuthTypeInterceptor
export class InstanceUidService {
  constructor(private cookieService: CookieService) {}

  init(): void {
    const uidFromCookies = this.getInstanceUidFormCookie();

    if (!uidFromCookies) {
      this.setInstanceUidInCookie(uuidv4());
    }
  }

  getInstanceUidFormCookie(): string {
    return this.cookieService.get('instance-uid');
  }

  setInstanceUidInCookie(uid: string): void {
    this.cookieService.put('instance-uid', uid, {
      expires: new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 365),
    });
  }
}
